<template>
  <div class="w-[9rem]" ref="dropdownSupportContent">
    <a href="/faqs" @click="
      handleLinkClick(
        'FAQs',
        'Support',
        'https://onlinejain.com/faqs'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">FAQs</div>
        <!-- <div><img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"></div> -->
      </div>
    </a>
    <div @click="
      is_download_brochure_navAll = true;
    handleLinkClick(
      'Download Brochure',
      'Support',
      'Overall Brochure'
    );
    pushBrochureDownloadDataLayer({
      electiveTitle: 'Overall Brochure',
      ctaSection: 'Nav Bar',
    });
    " class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
      <div class="text-xs">Download Brochure</div>
      <!-- <div><img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"></div> -->
    </div>

    <a href="/contact-us/" @click="
      handleLinkClick(
        'Contact Us',
        'Support',
        'https://onlinejain.com/contact-us/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Contact Us</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="https://support.onlinejain.com/" @click="
      handleLinkClick(
        'Student Support',
        'Support',
        'https://support.onlinejain.com/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Student Support</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>

    <a href="/grievance-redressal/" @click="
      handleLinkClick(
        'Grievance Redressal',
        'Support',
        'https://onlinejain.com/grievance-redressal/'
      )
      ">
      <div class="flex justify-between items-center cursor-pointer p-3 hover:bg-[#EFEFEF]">
        <div class="text-xs">Grievance Redressal</div>
        <div>
          <!-- <img src="@/assets/nav/right-arrow.webp" class="w-[10px] h-[16px] object-contain" alt="right arrow"> -->
        </div>
      </div>
    </a>
  </div>
  <BrochureView v-show="is_download_brochure_navAll == true" @close-button="is_download_brochure_navAll = false" />

</template>


<script>
import BrochureView from "@/components/BrochureView.vue";

export default {
  data() {
    return {
      is_download_brochure_navAll: false,
    }},
    components: {
    BrochureView,

  },
  methods: {
    handleLinkClick(item) {
      // Emit the item click event with its data
      this.$emit("item-clicked", item);
    },
    pushBrochureDownloadDataLayer(item) {
      // Emit the item click event with its data
      this.$emit("brochure-item-clicked", item);
    },
  },
};
</script>